import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import Divider from "components/divider";
import Checkbox from "components/form/checkbox/Checkbox";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import Toggle from "components/form/toggle/Toggle";
import { isEmpty } from "helpers/Helpers";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    state: IPutTeeSheetSettings;
    updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function CartManagement(props: IProps) {
    const {state, updateState } = props;
    const {t} = useTranslation();
    function handleToggleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { id, checked } = event.target;
        if (id === "track_cart_numbers") {
            updateState("use_cart_inventory", false);
        }
        updateState(id as keyof IPutTeeSheetSettings, checked);
      }

      function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { id, value } = event.target;
        updateState(id as keyof IPutTeeSheetSettings, value);
      }

      function handleChangeDefaultCartsAvailable(e: React.ChangeEvent<HTMLInputElement>) {
        const updatedDefaultCartsAvailable = isEmpty(e.target.value) ? null : Number(e.target.value);
    
        if (
          isNaN(updatedDefaultCartsAvailable) ||
          updatedDefaultCartsAvailable < 0 ||
          updatedDefaultCartsAvailable % 1 !== 0
        ) {
          e.preventDefault();
        } else {
            updateState("default_carts_available", updatedDefaultCartsAvailable);
        }
      }


      return (
        <div className="p-2" >
            <FormLayout>
                <FormLayout.Group>
                <div>
                <Toggle
                  labelRight={"Track cart numbers"}
                  checked={!!state.track_cart_numbers || false}
                  onChange={handleToggleChange}
                  id="track_cart_numbers"
                />
                {state.track_cart_numbers ? (
                  <div className="ml-3">
                    <Checkbox
                      size="medium"
                      label={t("Use cart inventory")}
                      id="use_cart_inventory"
                      checked={!!state.use_cart_inventory || false}
                      onChange={handleToggleChange}
                    />
                  </div>
                ) : null}
              </div>
                </FormLayout.Group>
                <FormLayout.Group>
                <Toggle
                    labelRight={t("Enable cart bookings")}
                    id="enable_cart_bookings"
                    checked={!!state.enable_cart_bookings || false}
                    onChange={handleToggleChange}
                />
                </FormLayout.Group>
                <FormLayout.Group>
                <Toggle
                    labelRight={t("Validate power cart count")}
                    id="validate_power_cart_count"
                    checked={!!state.validate_power_cart_count || false}
                    onChange={handleToggleChange}
                    labelSupport={t("Only allow adding carts when enough are available")}
                />
                </FormLayout.Group>
                </FormLayout>
                <Divider/>
                <FormLayout>
                <FormLayout.Group>
                <Toggle
                    id={"send_maintenance_notifications"}
                    onChange={handleToggleChange}
                    checked={state?.send_maintenance_notifications}
                    labelRight={t("Send maintenance notifications")}
                />
                </FormLayout.Group>
                {state?.send_maintenance_notifications ? (
                <FormLayout.Group>
                    <Input
                        id={"maintenance_email"}
                        onChange={handleInputChange}
                        placeholder={t("Maintenance email")}
                        value={state.maintenance_email}
                        label={t("Maintenance Email")}
                        />
                </FormLayout.Group>
                ) : null}
                <FormLayout.Group>
                <Input
                    label={t("Maintenance time")}
                    type="number"
                    id="power_cart_maintenance_time"
                    value={state.power_cart_maintenance_time === null ? 0 : state.power_cart_maintenance_time}
                    onChange={handleInputChange}
                    suffix={t("Minutes")}
                    tooltipText={t("Time a cart remains unavailable while in maintenance (minutes)")}
                />
                <Input
                    label={t("9 hole time")}
                    type="number"
                    id="power_cart_nine_hole_time"
                    value={state.power_cart_nine_hole_time === null ? 0 : state.power_cart_nine_hole_time}
                    onChange={handleInputChange}
                    suffix={t("Minutes")}
                    tooltipText={t("Time a cart is reserved for a 9-hole booking (minutes)")}
                />
                <Input
                    label={t("18 hole time")}
                    type="number"
                    id="power_cart_eighteen_hole_time"
                    value={state.power_cart_eighteen_hole_time === null ? 0 : state.power_cart_eighteen_hole_time}
                    onChange={handleInputChange}
                    suffix={t("Minutes")}
                    tooltipText={t("Time a cart is reserved for an 18-hole booking (minutes)")}
                />
            </FormLayout.Group>
            {!state.use_cart_inventory && (
              <FormLayout.Group>
                <Input
                  label={t("Carts available")}
                  value={state.default_carts_available ?? ""}
                  onChange={handleChangeDefaultCartsAvailable}
                />
              </FormLayout.Group>
            )}
            </FormLayout>
        </div>
      );
}